import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {_find, _finds, isArray} from "../../ccl-util";
import {ListService} from "../../list.service";
import {Subject} from "rxjs";
import {debounceTime, switchMap} from "rxjs/operators";
import {ListControlValueAccessor} from "../list-control-value-accessor";

@Component({
    selector: 'ccl-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.css'],
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: SelectComponent, multi: true}]
})
export class SelectComponent extends ListControlValueAccessor implements OnInit, OnChanges {
    constructor(listService: ListService, cdr: ChangeDetectorRef) {
        super(listService, cdr);
    }

    // ç»ä»¶æ¨¡å¼ï¼multiple å¤éï¼ default åéï¼tags æ ç­¾
    @Input()
    mode: 'multiple' | 'default' | 'tags' = 'default';

    // æå¡æç´¢æ¨¡å¼(ä¸åé¡µ)
    @Input()
    liveSearch = '';

    // åé¡µæå¡æç´¢æ¨¡å¼
    @Input()
    pagingLiveSearch = '';

    // è¥è®¾ç½®ä¸ºtrueï¼åå¦ængModelæå¼ï¼å°èªå¨è§¦å liveSearch æå¡è°ç¨ï¼ngModelçå¼å°ä½ä¸ºæç´¢åæ°åé
    @Input()
    autoLiveSearchFromValue = false;

    // å½è¾å¥åå®¹ä¸ºç©ºæ¶ï¼æ¯å¦è§¦åæç´¢
    @Input()
    emptySearch = false;

    // éæ©æ¡é»è®¤æå­
    @Input()
    placeHolder = '';

    // æ¯å¦æ¾ç¤ºä¸æå°ç®­å¤´ é»è®¤true
    @Input()
    showArrow = true;

    // éæ©æ¡å¤§å°
    @Input()
    size: 'large' | 'small' | 'default' = 'default';

    // æ¯å¦èªå¨è·åç¦ç¹
    @Input()
    autoFocus = false;

    // æ¯ææ¸é¤é»è®¤false
    @Input()
    allowClear = false;

    // è¥ä¸ºå¤éæ¶ï¼æå¤æ¯æéæ©å é¡¹
    @Input()
    maxMultipleCount = Number.MAX_VALUE;

    // è¥ä¸ºå¤éæ¶ï¼æå¤æ¯ææ¾ç¤ºå é¡¹
    @Input()
    maxTagCount = 2;

    // å®½åº¦
    @Input()
    width;

    // æå°å®½åº¦
    @Input()
    minWidth;

    // æ æ°æ®æ¶æ¾ç¤ºçæç¤º
    @Input()
    notFoundContent = 'æ æ°æ®å±ç¤º';

    ngOnInit() {
        this.initNgOnChanges = true;
        if (this.invokeService) {
            this.loadInvokeServiceData();
        }
        if (this.listService) {
            this.buildLiveSearchServer();
            if (this.emptySearch || this.valueName) {
                this.onSearch(this.valueName || '');
            }
        }
        if (this.pagingLiveSearch) {
            this.buildPagingLiveSearchServer();
            if (this.emptySearch || this.valueName) {
                this.onSearch(this.valueName || '');
            }
            if (this.autoLiveSearchFromValue) {
                setTimeout(() => {
                    if (this.value) {
                        this.onSearch(this.value);
                    }
                }, 13);
            }
        }
    }

    // å¤é¨ Control å¼åçååæ¶ï¼å°å¼è®¾ç½®ç» select
    writeValue(value: any): void {
        let noChange = true;
        let _value = value;
        if (value !== null && value !== undefined && value !== '') {
            if (this.mode === 'multiple') {
                if (!isArray(value)) {
                    _value = [String(value)];
                    noChange = false;
                } else {
                    _value = value.map(item => String(item));
                    noChange = JSON.stringify(_value) === JSON.stringify(value);
                }
            } else if (this.mode === 'default') {
                _value = String(value);
                noChange = _value === value;
            }
        } else {
            _value = null;
        }

        this.value = _value;

        if (this.autoLiveSearchFromValue && _value) {
            if (this.pagingLiveSearch) {
                this.onSearch(_value);
            } else if (this.liveSearch) {
                this.onSearch(_value);
            }
        }

        if (this.dataList.length) {
            this.changeValue(_value, noChange);
        }
    }

    // å½ä¸æç»ä»¶çå¼åçååï¼å°å¼æ¨éå° Control
    changeValue(value, noChange?) {
        if (this.mode === 'default') {
            const el = _find(this.dataList, 'value', value) || {};

            this.valueNameChange.emit(el.label || null);
            this.sourceValueChange.emit(el._source || null);
        } else if (this.mode === 'multiple' && isArray(value)) {
            const els = _finds(this.dataList, 'value', ...value);

            this.valueNameChange.emit(els.map(item => item.label));
            this.sourceValueChange.emit(els.map(item => item._source));
        }
        if (!value) {
            this.valueNameChange.emit(null);
            this.sourceValueChange.emit(null);
        }
        if (!noChange) {
            this.onChange && this.onChange(value);
        }
    }

    // å½ä¸ææ¡å³é­çæ¶åï¼å°touchedç¶ææ¨éç» Control
    openChange(open) {
        if (open === false) {
            this.onTouched && this.onTouched();
        }
    }

    // ********************* liveSearch *********************
    searchChange$: Subject<any>; // è¿ç¨æç´¢æ¶ï¼è§¦åæç´¢ççå¬å¨

    // æ®éæç´¢æ¨¡å¼
    buildLiveSearchServer() {
        if (this.searchChange$) {
            this.searchChange$.unsubscribe();
        }
        this.searchChange$ = new Subject();

        this.searchChange$
            .pipe(debounceTime(500))
            .pipe(switchMap((searchText: string) => {
                this.loading = true;
                return this.listService.invokeListProvider(this.liveSearch, this.invokeServiceParam, searchText);
            }))
            .subscribe((res) => {
                this.buildSourceListAsRes(res);
                this.loading = false;
                this.cdr.markForCheck();
            });
    }

    // ********************* pagingLiveSearch *********************
    pagingSearchChange$: Subject<any>; // è¿ç¨åé¡µæç´¢æ¶ï¼è§¦åæç´¢ççå¬å¨

    @Input()
    pageSize = 30; // é»è®¤æ¯é¡µå è½½30æ¡
    pagingSearchTextCache = ''; // ç¼å­æç´¢åæ°
    currentPage = 1; // å½åæ¥è¯¢é¡µæ°
    total = 0; // æ»æ¡æ°

    // åé¡µæç´¢æ¨¡å¼
    buildPagingLiveSearchServer() {
        if (this.pagingSearchChange$) {
            this.pagingSearchChange$.unsubscribe();
        }
        this.pagingSearchChange$ = new Subject();


        let append = true;
        this.pagingSearchChange$
            .pipe(debounceTime(500))
            .pipe(switchMap((pagingParam) => {
                append = !!pagingParam.total;
                this.loading = true;
                return this.listService.invokeListProvider(this.pagingLiveSearch, this.invokeServiceParam, pagingParam);
            }))
            .subscribe((res: any) => {
                if (res && res.code === 0 && res.data) {
                    this.total = res.data.total;
                    this.currentPage = res.data.currentPage;
                    this.buildSourceList(res.data.rows, append);
                }
                this.loading = false;
                this.cdr.markForCheck();
            });
    }

    // å½æ»å¨å°æåºé¨(è¥ä½¿ç¨å¼æ­¥å è½½æ¶ï¼å¯å¨æ­¤æ¶è§¦åå è½½æ´å¤æ°æ®è¯·æ±)
    scrollBottom() {
        if (this.pagingSearchChange$ && this.pagingLiveSearch) {
            if (this.dataList.length < this.total) {
                this.pagingSearchChange$.next({
                    searchText: this.pagingSearchTextCache,
                    pageSize: this.pageSize,
                    currentPage: this.currentPage + 1,
                    total: this.total
                });
            }
        }
    }

    // ********************* è¿ç¨æç´¢ *********************
    async onSearch(searchText) {
        if (!this.emptySearch && !searchText) {
            return;
        }

        if (this.liveSearch && this.searchChange$) {
            this.searchChange$.next(searchText);
        }

        if (this.pagingLiveSearch && this.pagingSearchChange$) {
            // ç¼å­æ¥è¯¢åæ°ï¼ä»¥ä¾¿æ»å¨å°åºé¨å è½½å¶å®é¡µæ°æ¶ä½¿ç¨
            this.pagingSearchTextCache = searchText;
            // æ¯æ¬¡æç´¢ï¼æ»æ¯ä»ç¬¬ä¸é¡µéæ°å è½½
            this.currentPage = 1;

            this.pagingSearchChange$.next({
                searchText,
                pageSize: this.pageSize,
                currentPage: this.currentPage
            });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (this.initNgOnChanges) {
            // å¨è°ç¨ç¨æ·æ¥å£æ¶ï¼è¥åç°åæ°ååï¼åéæ°è§¦åè°ç¨
            if (changes.invokeServiceParam && this.invokeService) {
                this.loadInvokeServiceData();
            }

            if (changes.listService) {
                this.buildLiveSearchServer();
            }

            if (changes.pagingLiveSearch) {
                this.buildPagingLiveSearchServer();
            }
        }
    }
}
